<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Support
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/support/tickets"
                        >Tickets</router-link
                      ></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
              <div
                class="card-header bg-white border-bottom_eee pt-1 px-1 mb-0 common_top_title_searchbgst_dock"
              >
                <div class="w-auto px-0 mobile-padding-0-2">
                  <div
                    class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                  >
                    <div class="avatar-content">
                      <em class="lab la-docker i_icon_st font-medium-5"></em>
                    </div>
                  </div>
                  <h4 class="card-title d-inline-flex ml-0 mb-0">
                    Tickets
                  </h4>
                </div>
              </div>
              <div class="card-body pt-1">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                          <label class="form-label text-left w-100">Ticket Code</label>
                          <input type="text" class="form-control" placeholder="Enter ticket code" v-model="searchTKCode" />
                      </div>
                        <template>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                            <label class="form-label text-left w-100">Query Type</label>
                            <treeselect  placeholder="Select Query Type" v-model="searchQueryType" :options="query_list" />
                        </div>
                        </template>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-4  text-left mb-1 home_das_all_buttons_style mobileview_b_8 ">
                              <label class="w-100 d-block">&nbsp; </label>
                            <button type="submit" class="btn btn-outline-primary mr-1 waves-effect  mr-1" @click="getTickets()">
                                Search
                            </button>
                            <button type="submit" class="btn btn-outline-primary waves-effect mr-1" @click="searchReset">
                                clear
                            </button>
                        </div>
                    </div>
                </div>
              
                <div class="table-responsive datatableview" id="list" >
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Ticket Code</th>
                        <th> Subject </th>
                        <th> Query/Category Type </th>
                        <th> Assignee </th>
                        <th> Status </th>
                        <th> Priority </th>
                        <th> Action </th>
                      </tr>
                    </thead>
                    <tbody>
                      <vue-element-loading :active="isListLoading" />
                      <template v-for="(data, idx) in list">
                        <tr>
                          <td data-column="code">{{data.ticket_code ? data.ticket_code : 'NA'}}</td>
                          <td data-column="Subject" > {{data.subject}}</td>
                          <td data-column="Query"> {{data.query_name}}</td>
                          <td data-column="Assignee"> {{data.assignee_id}}</td>
                          <td data-column="Status"> {{data.status}}</td>
                          <td data-column="Priority"> {{data.priority}}</td>
                          <td data-column="Action">
                            <a v-on:click="getDetails(data.ticket_id)" href="javascript:void(0);" class="dropdown-item devEditEle">
                              <div class="d-flex align-items-center"> 
                                <eye-icon size="1.5x" class="custom-class mr-50" style="color:blue"></eye-icon>
                                <span>View</span>
                              </div>
                            </a>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                    <template v-if="!list.length">
                      <tr>
                        <td colspan="6">No data to show</td>
                      </tr>
                    </template>
                  </table>
                </div>
              <div class="pageCenter text-center mt-4">
                <pagination v-model="page" :records="totalcount" :per-page="pagelimit" @paginate="handlePageChange"/>
              </div>
            </div>
          </section>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Quagga from "quagga";
import "vue2-datepicker/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueElementLoading from "vue-element-loading";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import searchMasterNameList from "../../../utils/searchMasterNameList";
import common_methods from "../../../utils/common_methods";
import axios from "axios"
import CONSTANT from "../../../constants.js"
import Pagination from 'vue-pagination-2'
import {
  EyeIcon
} from "vue-feather-icons";

export default {
  name: "Ticket",
  mixins: [searchMasterNameList, common_methods],
  data() {
    return {
      isListLoading: false,
      isLoading: false,
      query_list: [],
      list: [],
      totalcount: 0,
      pageCount: 0,
      page: 1,
      pagelimit: CONSTANT.LIMIT,
      currPageNum: 0,
      pageoffset: 1,
      searchQueryType:null,
      searchTKCode:''
    };
  },
  components: {
    DatePicker,
    Treeselect,
    Loading,
    VueElementLoading,
    VueTimepicker,
    Pagination,
    EyeIcon,
  },
  mounted() {
    if (!localStorage.getItem("reloaded")) {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (feather) {
      feather.replace({
        width: 14,
        height: 14,
      });
    }
    $(window).on("load", function () {
      if (feather) {
        feather.replace({
          width: 14,
          height: 14,
        });
      }
    });
    this.getQueryList()
  },
  created() {
    this.getTickets()
  },
  methods: {
    getDetails(id) {
      let routeData = this.$router.resolve({ 
        path: `/support/tickets/${id}`,
      })
      window.open(routeData.href, '_blank');
    },
    getTickets() {
      this.isListLoading = true
      let url = "/support/tickets"
      let payload = {
        page: this.page,
        rows: this.pagelimit,
        ticket_code: this.searchTKCode,
        query_type:this.searchQueryType
      }
      this.makeRequest("POST", url, payload)
        .then(result => {
          this.isListLoading = false
          this.list = result.data.data.rows
          this.totalcount = result.data.data.count
          this.pageCount = Math.ceil(result.data.data.count / this.pagelimit)
        })
        .catch(e => {
          this.isListLoading = false
          this.displayError(e)
        })
    },
    handlePageChange(pageNum) {
      this.pageoffset = pageNum
      this.currPageNum = pageNum - 1
      this.getTickets();
      setTimeout(function(){
          $('html, body').animate({
              scrollTop: $("#list").offset().top -70
          });
      }, 500);
    },
    getQueryList() {
      this.searchNameMasterList('query_type', 'query_name', null, 'query_id')
        .then(result => {
          this.query_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    searchReset(){
      this.searchQueryType = null,
      this.searchTKCode = null.
      this.getTickets()
    }
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}

</style>
